import { render, staticRenderFns } from "./examPage.vue?vue&type=template&id=10552c48&scoped=true"
import script from "./examPage.vue?vue&type=script&lang=js"
export * from "./examPage.vue?vue&type=script&lang=js"
import style0 from "./examPage.vue?vue&type=style&index=0&id=10552c48&prod&lang=less&scoped=true"
import style1 from "./examPage.vue?vue&type=style&index=1&id=10552c48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10552c48",
  null
  
)

export default component.exports